import { render, staticRenderFns } from "./FedExAddressForm.vue?vue&type=template&id=d2628c7a"
import script from "./FedExAddressForm.vue?vue&type=script&lang=js"
export * from "./FedExAddressForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports